import { render, staticRenderFns } from "./PriceList.vue?vue&type=template&id=49413ba6&"
import script from "./PriceList.vue?vue&type=script&lang=js&"
export * from "./PriceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports